<template>
    <h3 style="height:400px" v-if="is_fetching" class="d-flex align-center justify-center font-weight-light text-center outfit-font">
        <div>
            <v-progress-circular indeterminate color="primary"/>
            Loading catalog items...
        </div>
    </h3>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'

const store = useGlobalsStore()
const { is_fetching } = storeToRefs(store)
</script>
